import React from 'react';
import { getPaintMembership } from '../../../utils/GeneralUtil';
import { PerkRewards, Rewards, BusinessTools, PaintRewards, ExclusiveSavings, PreferredPricing, EliteSupportLine, AccountManagement, VIPExperiences, PerkTracker, OfferRewards, SquareBenefits, } from '../TierBenefits';
import { useIsMobile, useBenefitTag } from '../../../hooks';
import { BenefitContainer } from './Utils';
import { DrawerContext, InfoRewardsContext, RewardsAndOffersContext, } from '../../../contexts';
import { CardRowContainerHalfWidth, CardRowContainerFullWidth, } from '../../shared/rewards-hub/benefit-card';
import { getUserRole } from '../../Utils';
import { benefitTags } from '../../../constants/RewardsHub';
import { PLCCEntryPoint } from '../TierBenefits/PLCC/PLCCEntryPoint';
import { TopSavingsForYou } from '../../shared/rewards-hub/top-savings/top-savings-for-you';
/**
 * PerksOffersBenefits Component
 *
 * Renders the Perks and Offers section for enrolled Pro Xtra members.
 * When IS_TOP_SAVINGS is set to 'middle', TopSavings component is inserted
 * after Perks/Offers cards but before the PerkTracker (Your Next Perk).
 */
var PerksOffersBenefits = function (_a) {
    var _b;
    var isLocked = _a.isLocked;
    var isMobile = useIsMobile().isMobile;
    var _c = React.useContext(RewardsAndOffersContext), rewardsAndOffers = _c.rewardsAndOffers, showTopSavingsAtMiddle = _c.showTopSavingsAtMiddle;
    var enrolledInPerksProgram = ((rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.customerInfo) || {}).enrolledInPerksProgram;
    var nationalAccount = (_b = rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.customerInfo) === null || _b === void 0 ? void 0 : _b.nationalAccount;
    var isGovernmentAcct = !enrolledInPerksProgram && nationalAccount;
    var isPurchaser = getUserRole() === 'PURCHASER';
    var isPacDrawersEnabled = React.useContext(DrawerContext).isPacDrawersEnabled;
    var isBlendedRewardsEnabled = React.useContext(InfoRewardsContext).isBlendedRewardsEnabled;
    var RenderBlendedRewards = function () { return (React.createElement(React.Fragment, null,
        enrolledInPerksProgram && (React.createElement(CardRowContainerHalfWidth, null,
            React.createElement(Rewards, { isMobile: isMobile }),
            React.createElement(PerkTracker, null))),
        showTopSavingsAtMiddle && enrolledInPerksProgram && React.createElement(TopSavingsForYou, null),
        isPacDrawersEnabled && (React.createElement(CardRowContainerFullWidth, null,
            React.createElement("div", { className: "".concat(isMobile ? 'sui-mt-10' : '') },
                React.createElement(PLCCEntryPoint, { isMobile: isMobile, fullWidth: true })))))); };
    var RenderUnblendedRewards = function () { return (React.createElement(React.Fragment, null,
        enrolledInPerksProgram && (React.createElement(CardRowContainerHalfWidth, null,
            React.createElement(PerkRewards, { isMobile: isMobile, autoFetch: false }),
            React.createElement(OfferRewards, { isMobile: isMobile, autoFetch: false }))),
        showTopSavingsAtMiddle && enrolledInPerksProgram && React.createElement(TopSavingsForYou, null),
        isPacDrawersEnabled && enrolledInPerksProgram && (React.createElement(CardRowContainerHalfWidth, null,
            React.createElement(PerkTracker, null),
            React.createElement("div", { className: "".concat(isMobile ? 'sui-mt-10' : '') },
                React.createElement(PLCCEntryPoint, { isMobile: isMobile })))),
        isPacDrawersEnabled && !enrolledInPerksProgram && (React.createElement(CardRowContainerFullWidth, null,
            React.createElement("div", { className: "".concat(isMobile ? 'sui-mt-10' : '') },
                React.createElement(PLCCEntryPoint, { isMobile: isMobile, fullWidth: true })))))); };
    return (React.createElement(BenefitContainer, { tierName: "Member", isLocked: isLocked }, !isGovernmentAcct && !isPurchaser && (React.createElement("div", null, isBlendedRewardsEnabled ? (React.createElement(RenderBlendedRewards, null)) : (React.createElement(RenderUnblendedRewards, null))))));
};
var MemberBenefits = function (_a) {
    var isLocked = _a.isLocked;
    var isMobile = useIsMobile().isMobile;
    var _b = React.useContext(RewardsAndOffersContext), rewardsAndOffers = _b.rewardsAndOffers, showTopSavingsAtMiddle = _b.showTopSavingsAtMiddle;
    var paintMembership = getPaintMembership(rewardsAndOffers);
    var paintStatus = paintMembership === null || paintMembership === void 0 ? void 0 : paintMembership.membershipStatus;
    var showPaintRewards = paintStatus === 'ACTIVE';
    return (React.createElement(BenefitContainer, { tierName: "Member", isLocked: isLocked },
        showPaintRewards ? (React.createElement(CardRowContainerHalfWidth, null,
            React.createElement(PaintRewards, { isMobile: isMobile, isLocked: isLocked }),
            React.createElement(BusinessTools, { isMobile: isMobile, isLocked: isLocked }))) : (React.createElement(CardRowContainerFullWidth, null,
            React.createElement(BusinessTools, { isMobile: isMobile, isLocked: isLocked }))),
        !showTopSavingsAtMiddle && (React.createElement(CardRowContainerFullWidth, null,
            React.createElement(ExclusiveSavings, { isMobile: isMobile, isLocked: isLocked })))));
};
var EliteBenefits = function (_a) {
    var _b;
    var isLocked = _a.isLocked;
    var isMobile = useIsMobile().isMobile;
    var _c = React.useContext(RewardsAndOffersContext), rewardsAndOffers = _c.rewardsAndOffers, isSquareBenefitsEnabled = _c.isSquareBenefitsEnabled;
    var phoneNumber = useBenefitTag(benefitTags.eliteSupportLine);
    var isVIP = ((_b = rewardsAndOffers === null || rewardsAndOffers === void 0 ? void 0 : rewardsAndOffers.proTiers) === null || _b === void 0 ? void 0 : _b.currentTierName) === 'VIP';
    return (React.createElement(BenefitContainer, { tierName: "Elite", isLocked: isLocked }, isSquareBenefitsEnabled && !isVIP ? (React.createElement(React.Fragment, null,
        React.createElement(CardRowContainerFullWidth, null,
            React.createElement(PreferredPricing, { isMobile: isMobile, isLocked: isLocked, fullWidth: true })),
        React.createElement(CardRowContainerHalfWidth, null,
            React.createElement(EliteSupportLine, { isMobile: isMobile, isLocked: isLocked, phoneNumber: phoneNumber }),
            React.createElement(SquareBenefits, { isMobile: isMobile, isLocked: isLocked, tierName: "Elite" })))) : (React.createElement(CardRowContainerHalfWidth, null,
        React.createElement(EliteSupportLine, { isMobile: isMobile, isLocked: isLocked, phoneNumber: phoneNumber }),
        React.createElement(PreferredPricing, { isMobile: isMobile, isLocked: isLocked })))));
};
var VipBenefits = function (_a) {
    var isLocked = _a.isLocked;
    var isMobile = useIsMobile().isMobile;
    var isSquareBenefitsEnabled = React.useContext(RewardsAndOffersContext).isSquareBenefitsEnabled;
    return (React.createElement(BenefitContainer, { tierName: "VIP", isLocked: isLocked }, isSquareBenefitsEnabled ? (React.createElement(React.Fragment, null,
        React.createElement(CardRowContainerFullWidth, null,
            React.createElement(AccountManagement, { isMobile: isMobile, isLocked: isLocked, fullWidth: true })),
        React.createElement(CardRowContainerHalfWidth, null,
            React.createElement(VIPExperiences, { isMobile: isMobile, isLocked: isLocked }),
            React.createElement(SquareBenefits, { isMobile: isMobile, isLocked: isLocked, tierName: "VIP" })))) : (React.createElement(CardRowContainerHalfWidth, null,
        React.createElement(VIPExperiences, { isMobile: isMobile, isLocked: isLocked }),
        React.createElement(AccountManagement, { isMobile: isMobile, isLocked: isLocked })))));
};
export var BENEFIT_LISTS = {
    VIP: VipBenefits,
    ELITE: EliteBenefits,
    MEMBER: MemberBenefits,
    PERKOFFERS: PerksOffersBenefits,
};
